// extracted by mini-css-extract-plugin
export var dot = "_qr-2";
export var wave = "_qr-0";
export var waveSmall = "_qr-1";